const PRODUCT = "vtuber-search:20260809";

export async function logAction(action, payload = {}) {
  const user = localStorage.getItem("user") ?? null;
  const body = {
    product: PRODUCT,
    action,
    user,
    payload,
  };

  try {
    const response = await fetch("https://daikou-diverse-api.com/api/common/log", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      console.log(`${action} のログ送信に失敗しました`);
      return null;
    }

    const responseText = await response.text();
    let result = null;

    if (responseText) {
      try {
        result = JSON.parse(responseText);
      } catch (error) {
        console.warn("ログレスポンスのパースに失敗しました", error);
      }
    }

    if (result?.user) {
      localStorage.setItem("user", result.user);
    }

    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
}
